import { useEffect } from 'react';

import { useFetchCurrentUser } from '../api/hooks/auth';
import { identifyClarityUser } from '../utils/initClarity';

/**
 * 로그인 이후 Microsoft Clarity 세션에 사용자 정보를 태깅하는 실험용 훅.
 * 현재 사용자 정보가 확인되면 병원 ID와 employee id를 Clarity 세션에 태깅한다.
 * (스크립트 주입 자체는 앱 부팅 시 initClarity()가 담당)
 */
export function useClarityUser(): void {
  const { data: currentUser } = useFetchCurrentUser();

  useEffect(() => {
    if (!currentUser) return;
    identifyClarityUser({ employeeId: currentUser.id, orgzId: currentUser.orgzId });
  }, [currentUser]);
}
